// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup_tpl[data-v-d7a06610] {\n  margin-bottom: 2.4rem;\n}\n.popup_content[data-v-d7a06610] {\n  padding: 1.6rem 0.64rem 0rem;\n}\n.vote_content[data-v-d7a06610] {\n  padding: 0.4266666667rem 0.64rem 0rem 0 !important;\n}\n.vote_list[data-v-d7a06610] {\n  list-style: disc;\n  padding-left: 0.4266666667rem;\n  line-height: 0.56rem;\n  margin-left: 0.2666666667rem;\n}", ""]);
// Exports
module.exports = exports;
